export const handleChangeOpenImport = value => dispatch => dispatch({ type: 'CHANGE_OPEN_IMPORT', payload: value })

export const handleAddDataImport = value => dispatch => dispatch({ type: 'ADD_UPLOAD_DATA_IMPORT', payload: value })
